import React from "react";
import { Space, Button, Typography, Steps, Col, Row, Card } from "antd";
import {
  DownloadOutlined,
  EyeOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  FileOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

function Home() {
  return (
    <>
      <Space
        align={"center"}
        direction={"vertical"}
        className="center-content"
        style={{ minHeight: "60vh", backgroundColor: "#FAFAFA" }}
      >
        <Space
          align={"center"}
          direction={"vertical"}
          className="center-content"
          style={{ marginBottom: "130px" }}
        >
          <img
            style={{ maxWidth: "10rem" }}
            src={process.env.PUBLIC_URL + "/imgs/logo-inline.png"}
            alt="VCAT logo"
          />
          <Title level={1}>Visual Content Assessment Tool</Title>
          <Title level={4}>
            Helping contributors bridge gaps in Wikipedia's visual content.
          </Title>
          <div className="divider-small"></div>
          <Space direction="horizontal">
            <Button
              href={`${window.location.pathname}#/dashboard`}
              type={"primary"}
            >
              Use the dashboard
            </Button>
            <Button
              href={`${window.location.pathname}#/extraction`}
              type={"default"}
            >
              Extract data
            </Button>
          </Space>
        </Space>
      </Space>

      <Space
        align={"center"}
        direction={"vertical"}
        className="center-content"
        style={{ marginTop: "-230px" }}
      >
        <img
          style={{ filter: "none", maxWidth: "1200px" }}
          className="image-home"
          src={process.env.PUBLIC_URL + "/imgs/dashboard_components.png"}
          alt="dashborad"
        />
      </Space>
      <div className="divider-big"></div>
      <Space
        align={"center"}
        direction={"vertical"}
        size={0}
        className="center-content"
      >
        <Title level={3}>Detect visual gaps and contribute to Wikipedia</Title>
        <Text>
          The tool helps contributors to detect visual gap within Wikiprojects.
        </Text>
      </Space>
      <div className="divider-medium"></div>
      <Space
        align={"center"}
        direction={"vertical"}
        className="center-content"
        style={{
          display: "contents",
          maxWidth: "1200px",
        }}
      >
        <Steps
          type="navigation"
          size="big"
          current={4}
          style={{
            padding: "6rem 10rem",
            backgroundColor: "#FAFAFA",
          }}
          items={[
            {
              title: "Extract",
              status: "fnish",
              icon: <DownloadOutlined />,
              description: "Extract data from any Wikiproject.",
            },
            {
              title: "Explore",
              status: "fnish",
              icon: <EyeOutlined />,
              description: "Explore the data using the dashboard.",
            },
            {
              title: "Detect",
              status: "fnish",
              icon: <SearchOutlined />,
              description: "Detect visual gaps within articles.",
            },
            {
              title: "Contribute",
              status: "fnish",
              icon: <CheckCircleOutlined />,
              description: "Contribute to the visual side of WIkipedia.",
            },
          ]}
        />
      </Space>
      <div className="divider-big"></div>
      <Space
        align={"center"}
        direction={"vertical"}
        size={0}
        className="center-content"
      >
        <Title level={3}>Improve Wikipedia using VCAT</Title>
        <Text>
          The tool enables some useful actions to improve the visual side of
          Wikipedia.
        </Text>
      </Space>
      <div className="divider-medium"></div>
      <Space
        align={"center"}
        direction={"horizontal"}
        size={0}
        className="center-content"
      >
        <Card
          className="contribution-card"
          bordered={false}
          cover={
            <img
              src={process.env.PUBLIC_URL + "/imgs/contributions-01.jpg"}
              alt="visual coverage"
            />
          }
        >
          <Text strong>Monitor the visual coverage in Wikiprojects</Text>
        </Card>
        <Card
          className="contribution-card"
          bordered={false}
          cover={
            <img
              src={process.env.PUBLIC_URL + "/imgs/contributions-02.jpg"}
              alt="articles needing images"
            />
          }
        >
          <Text strong>Identify relevant articles that need images</Text>
        </Card>
        <Card
          className="contribution-card"
          bordered={false}
          cover={
            <img
              src={process.env.PUBLIC_URL + "/imgs/contributions-03.jpg"}
              alt="images to improve"
            />
          }
        >
          <Text strong>Identify low quality images to improve</Text>
        </Card>
      </Space>
      <div className="divider-big"></div>
      <Space
        align={"center"}
        direction={"vertical"}
        size={0}
        className="center-content"
      >
        <Title level={3}>Getting started</Title>
        <Text>
          Follow the guide to extract Wikiproject data and explore them using
          the dashboard.
        </Text>
      </Space>
      <div className="divider-medium"></div>

      <Space
        align={"center"}
        direction={"vertical"}
        size={0}
        className="center-content"
      >
        <iframe
          width="840"
          height="472"
          src="https://www.youtube.com/embed/P6i60eEspB8"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          style={{ borderRadius: "10px" }}
        ></iframe>
      </Space>

      {/* <Space
        align={"center"}
        direction={"vertical"}
        size={0}
        className="center-content"
      >
        <Title level={3}>Extract Wikiproject’s data</Title>
        <Text>
          Use the extraction tool to get data of any Wikiproject or list of
          articles.
        </Text>
        <div className="divider-small"></div>
        <Button type="default" href={`${window.location.pathname}#/extraction`}>
          Extract data
        </Button>
      </Space>
      <div className="divider-medium"></div>

      <Space
        align={"center"}
        direction={"vertical"}
        size={0}
        className="center-content"
      >
        <img
          className="image-home"
          src={process.env.PUBLIC_URL + "/imgs/extraction_tool.jpg"}
          alt="extraction tool"
        />
        <Space
          align={"center"}
          direction={"vertical"}
          size={15}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            padding: "2rem",
            marginTop: "-50%",
            filter: "drop-shadow(0px 0px 30px #040d3320)",
          }}
        >
          <FileOutlined style={{ fontSize: "5rem" }} />
          <Text>wp_eclipses.json</Text>
        </Space>
      </Space>

      <div className="divider-big"></div>
      <Space
        align={"center"}
        direction={"vertical"}
        size={0}
        className="center-content"
      >
        <Title level={3}>Explore the visual side of Wikipedia</Title>
        <Text>
          Use the dashboard to explore data and images of WIkiprojects or custom
          articles list.
        </Text>
        <div className="divider-small"></div>
        <Button type="default" href={`${window.location.pathname}#/dashboard`}>
          Use the dashboard
        </Button>
      </Space>
      <div className="divider-medium"></div>
      <Space align={"center"} direction={"vertical"} className="center-content">
        <img
          className="image-home"
          src={process.env.PUBLIC_URL + "/imgs/dashboard.jpg"}
          alt="dahborad"
        />
      </Space> */}
      <div className="divider-big"></div>
    </>
  );
}

export default Home;
